// Pacientes Routes
export const ROUTE_PACIENTES_LIST = '/pacientes/buscar/';
export const ROUTE_PACIENTES_FILE = '/pacientes/file/:pacienteId';
export const ROUTE_PACIENTES_NEW = '/pacientes/nuevo';
export const ROUTE_PACIENTES_EDIT = '/pacientes/editar/:pacienteId';
export const ROUTE_PACIENTES_WATCH = '/pacientes/watch/:pacienteId';
export const ROUTE_PACIENTES_GDPR = '/pacientes/rgpd/:pacienteId';
export const ROUTE_PACIENTES_GDPR_SIGN = '/pacientes/rgpd/:pacienteId/firmar';
export const ROUTE_PACIENTES_EYECHART_NEW = '/pacientes/optometria/:pacienteId/nuevo';
export const ROUTE_PACIENTES_EYECHART_EDIT = '/pacientes/optometria/:pacienteId/:codigo/:tiendaGraduacion/editar';
export const ROUTE_PACIENTES_EYECHART_WATCH = '/pacientes/optometria/:pacienteId/:codigo/:tiendaGraduacion/watch';
export const ROUTE_PACIENTES_CONTACTOLOGY_NEW = '/pacientes/:pacienteId/contactologia/nuevo';
export const ROUTE_PACIENTES_CONTACTOLOGY_WATCH = '/pacientes/:pacienteId/contactologia/:codigo/:tiendaGraduacion/mostrar';
export const ROUTE_PACIENTES_CONTACTOLOGY_EDIT = '/pacientes/:pacienteId/contactologia/:codigo/:tiendaGraduacion/editar';
export const ROUTE_PACIENTES_ERROR = '/pacientes/error';
export const ROUTE_DOCUMENT = '/drive/:entidadTipoId/carpeta/:entidadId/mostrar';
export const ROUTE_DOCUMENT_TIENDA = '/drive/:entidadTipoId/carpeta/:entidadId/tienda/:tiendaId/mostrar';
export const PEDIDOS_LENTES_CONTACTO = '/gw1/pel/seleccionar';